import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import FormBuilder from 'app/components/form/FormBuilder';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    saveButtonContainer: {
        padding: theme.spacing(3)
    },
    saveButton: {
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
    },
}));

export default function FormBuilderSettings(props) {

    const { loading, setLoading, getForm, form } = props;

    const classes = useStyles();
    const api = useApi();

    const [ fields, setFields ] = useState(form?.fields);
    const [ errors, setErrors ] = useState({});

    const formId = props.form.id;

    // getters

    useEffect(() => {
        setFields(form?.fields)
    }, [form]);

    // Post Function ------------------------------------------

    const postForm = () => {

        setLoading(true)

        const data = {...form, fields}

        if (form.starts_at) data.starts_at = form.starts_at.toSeconds();
        if (form.ends_at) data.ends_at = form.ends_at.toSeconds();

        api.post(`/admin/form/${formId}`, data)
            .then(() => getForm())
            .catch(error => {
                if (error?.response?.data?.errors) {
                    setErrors(error.response.data.errors)
                }
                setLoading(false);
            });
    }

    return (
        <>
            <FormBuilder
                fields={fields}
                setFields={setFields}
                errors={errors}
            />
            <Typography align="right" component="div" className={classes.saveButtonContainer}>
                <Button
                    disabled={loading}
                    variant="contained"
                    color="primary"
                    onClick={postForm}
                    className={classes.saveButton}
                    size="small"
                    >
                    save
                </Button>
            </Typography>
        </>
    );
}
